export const GET_DELIVERY_SLOTS_REQUEST = "GET_DELIVERY_SLOTS_REQUEST";
export const GET_DELIVERY_SLOTS_SUCCESS = "GET_DELIVERY_SLOTS_SUCCESS";
export const GET_DELIVERY_SLOTS_FAIL = "GET_DELIVERY_SLOTS_FAIL";
